import { EXTRA_SINGAL } from "@/commons/enums/extra-singal";
import { BasicControl, CURSOR_TYPE, dymode, DYMODE_MODE, LineT, Listeners, MOUSE, TnEngineContext, TnEngineExtraContext, ViewEditor } from "pytha";
import { Object3D, Object3DEventMap, Quaternion, Vector3 } from "three";



const STEP = {
    0: { 'tip': '选择对象', 'mode': DYMODE_MODE.TIPONLY },
    1: { 'tip': '指定基点', 'mode': DYMODE_MODE.POINT },
    2: { 'tip': '指定比例因子', 'mode': DYMODE_MODE.DIST },
}

export class ObjMeshGroupScaleControl extends BasicControl {

    id: number = 10087;

    // 基点
    point: Vector3 = new Vector3();

    point_down: Vector3 = new Vector3();

    // 比例因子
    scale_factor: number;

    step: number = 0;


    capturePoint: Vector3;

    dymodePoint: Vector3 = new Vector3();

    orthogonalPoint: Vector3;


    objMeshGroupUuids: string[] = [];
    objMeshGroups: Object3D<Object3DEventMap>[] = [];
    objMeshGroupFirstScales: Vector3[] = [];
    firstPoint: Vector3 = new Vector3(0, 0, 0);


    helpLine: LineT = new LineT();
    polarPoint: Vector3;
    context: TnEngineContext;
    extraContext: TnEngineExtraContext;
    constructor(editor: ViewEditor, listeners: Listeners, shouldConstruct: boolean = true) {
        super();
        if (!shouldConstruct) return;
        // 使用构造函数，在创建类的对象时，直接给成员变量赋值
        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.editor = editor;
        this.listeners = listeners;
        this.helpLine._isHelpLine = true;
        // 注册监听指针事件
        editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
        editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        // 派发置空选择集的信号
        // this.listeners.signals.emptySelectedEntities.dispatch();
        // 订阅选择信号，收听选择集信息
        // this.listeners.signals.onSelectChanged.add(this.onSelectChanged)
        // 订阅动态输入改变信号，收听到动态输入信息
        this.listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
        // 订阅确认信号
        this.listeners.signals.onKeyMouseConfirm.add(this.onKeyMouseConfirm);
        // 订阅点捕捉信号，收听到捕捉点的坐标
        this.listeners.signals.onPointCapture.add(this.onPointCapture);
        // 订阅正交信号，收听到正交模式点的坐标
        this.listeners.signals.onPointOrthogonal.add(this.onPointOrthogonal);
        this.listeners.signals.onPointPolarTracking.add(this.onPointPolarTracking);
        // 激活选择
        this.editor.selectControl.setEnabled(true);
        // 激活动态输入
        this.extraContext.dymodeContext.enabled = true;
        this.editor.clampControl.enabled = false;
        this.editor.clampControl.hidden = true;

        this.step++;
        // 钝化选择
        this.editor.selectControl.setEnabled(false);
        // 派发需要捕捉的信号
        this.listeners.signals.needCapture.dispatch();
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip + ':');
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);


        console.log('ScaleControl added')
        // this.dymodePoint.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
    }

    dispose(): void {

        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        this.listeners.getSignal(EXTRA_SINGAL.onObjMeshGroupChange).dispatch();
        // this.listeners.signals.onSelectChanged.remove(this.onSelectChanged);
        this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.listeners.signals.onPointOrthogonal.remove(this.onPointOrthogonal);
        this.listeners.signals.onPointPolarTracking.remove(this.onPointPolarTracking);
        this.listeners.signals.noNeedCapture.dispatch();
        // 派发置空选择集的信号
        this.listeners.signals.emptySelectedEntities.dispatch();
        this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = false;
        this.editor.clampControl.enabled = true;
        this.editor.clampControl.hidden = false;
        this.editor.orthogonalControl.enabled = false;
        this.editor.polarControl.enabled = false;
        let obj = this.helpLine.viewObj;
        if (obj && !!obj.parent) {
            obj.parent.remove(obj);
        }

        console.log('ScaleControl removed')
    }

    onPointPolarTracking = (point) => {
        this.polarPoint = point;
    }

    onPointCapture = (point) => {
        this.capturePoint = point;
    }

    onPointOrthogonal = (point) => {
        this.orthogonalPoint = point;
    }

    onPointerDown = (event) => {
        if (event.button !== MOUSE.LEFT) return;
        if (this.step === 0) {
            return;
        }
        if (this.capturePoint) {
            this.point_down.copy(this.capturePoint);
        } else if (this.orthogonalPoint) {
            this.point_down.copy(this.orthogonalPoint);
        } else if (this.polarPoint) {
            this.point_down.copy(this.polarPoint);
        } else {
            this.point_down.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        }
        if (this.step === 1) {
            this.point.copy(this.point_down);
            this.firstStep();
        } else if (this.step === 2) {
            let point = this.point;
            if (point.equals(this.point_down)) {
                this.point_down.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
            }
            let end = this.point_down;
            this.scale_factor = Math.sqrt((point.x - end.x) * (point.x - end.x) + (point.y - end.y) * (point.y - end.y) + (point.z - end.z) * (point.z - end.z));
            this.lastStep();
        }
    }

    onPointerMove = (event) => {
        this.dymodePoint.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        if (this.step === 2) {
            if (this.orthogonalPoint) {
                this.dymodePoint.copy(this.orthogonalPoint);
            }
            if (this.polarPoint) {
                this.dymodePoint.copy(this.polarPoint);
            }
            if (this.capturePoint) {
                this.dymodePoint.copy(this.capturePoint);
            }
            // 更新指示线
            this.helpLine.set(this.point, this.dymodePoint);
            this.helpLine.updateViewGeometry();
            let first = this.point;
            let second = this.dymodePoint;
            let scale = Math.sqrt((second.x - first.x) * (second.x - first.x) + (second.y - first.y) * (second.y - first.y) + (second.z - first.z) * (second.z - first.z));
            if (scale === 0) {
                scale = 1e-4;
            }

            const basePoint = this.firstPoint;

            this.objMeshGroups.forEach((objMeshGroup, index) => {
                const objMeshGroupFirstScale = this.objMeshGroupFirstScales[index];
                // 设置缩放后位置
                objMeshGroup.position.set(basePoint.x * (1 - scale), basePoint.y * (1 - scale), basePoint.z * (1 - scale));
                // 应用缩放
                objMeshGroup.scale.set(scale * objMeshGroupFirstScale.x, scale * objMeshGroupFirstScale.y, scale * objMeshGroupFirstScale.z);;
            });



        }
        this.editor.listeners.signals.needRender.dispatch();

    }

    firstStep = () => {

        if (this.objMeshGroupUuids == null || this.objMeshGroupUuids.length === 0) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        let objMeshGroups = [];
        this.extraContext.sceneContext.scene.children.forEach(obj => {
            if (this.objMeshGroupUuids.includes(obj.uuid)) {
                objMeshGroups.push(obj);
            }
        })
        if (!objMeshGroups || objMeshGroups.length === 0) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        this.objMeshGroups = objMeshGroups;

        this.objMeshGroups.forEach(objMeshGroup => {
            const objMeshGroupFirstScale = objMeshGroup.scale.clone();
            this.objMeshGroupFirstScales.push(objMeshGroupFirstScale);
        });

        this.helpLine.set(this.point, this.point);
        this.helpLine.color.set('#969c9a');
        this.listeners.signals.needCapture.dispatch(this.point);
        this.listeners.signals.orthogonal.dispatch(this.point);
        this.listeners.signals.polarTracking.dispatch(this.point);
        let view = this.helpLine.render();
        this.extraContext.sceneContext.scene.add(view);
        this.step++;
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip + ':');
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode, this.point);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);
        // this.extraContext.dymodeContext.target = this.point;
    }

    lastStep = () => {
        if (this.scale_factor <= 0) {
            this.extraContext.stmodeContext.pushTip('值必须为正且非零。')
            this.listeners.signals.sendToDymodeTip.dispatch('值必须为正且非零。' + STEP[this.step].tip + ':');
            this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);
            return;
        }

        const basePoint = this.firstPoint;
        const scale = this.scale_factor;

        this.objMeshGroups.forEach((objMeshGroup, index) => {
            const objMeshGroupFirstScale = this.objMeshGroupFirstScales[index];
            // 设置缩放后位置
            objMeshGroup.position.set(basePoint.x * (1 - scale), basePoint.y * (1 - scale), basePoint.z * (1 - scale));
            // 应用缩放
            objMeshGroup.scale.set(scale * objMeshGroupFirstScale.x, scale * objMeshGroupFirstScale.y, scale * objMeshGroupFirstScale.z);
        })


        this.listeners.signals.onOpeCommandControlEnd.dispatch();
    }

    _dymodeActive = false;

    onDymodeChanged = (value: dymode) => {
        if (value.mode === DYMODE_MODE.POINT) {
            this.dymodePoint.set(value.x, value.y, value.z);
            this._dymodeActive = true;
            this.onKeyMouseConfirm();
        } else if (value.mode === DYMODE_MODE.DIST) {
            this.scale_factor = value.dist;
            this._dymodeActive = true;
            this.onKeyMouseConfirm();
        }
    }

    onKeyMouseConfirm = () => {
        if (this.step === 0) {
            this.step++;
            // 钝化选择
            this.editor.selectControl.setEnabled(false);
            // 派发需要捕捉的信号
            this.listeners.signals.needCapture.dispatch();
            this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip + ':');
            this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
            this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);
            this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);
        } else if (this.step === 1) {
            this.point.copy(this.dymodePoint);
            // this.editor.dymodeControl.reset();
            this._dymodeActive = false;
            this.firstStep();
        } else if (this.step === 2) {
            if (this._dymodeActive) {
                // this.scale_factor = this.dymodePoint.x;
                this._dymodeActive = false;
                this.lastStep();
            } else {
                this.listeners.signals.onOpeCommandControlEnd.dispatch();
            }
        }
    }
}